import { DatePicker } from "antd";
import { BaseComponent } from "./baseComponent";

export class DateField extends BaseComponent {
  constructor() {
    super('date');
  }
  public renderComponent(item: any, pipe: any): any {
    const {
      id, type, placeholder, subType, cssClass, label,
      mandatory, mandatoryMessage,
      ...otherProps
    } = item;
    return <DatePicker key={id} placeholder={ pipe.t(placeholder) } label={ pipe.t(label) } className={ cssClass } {...otherProps} />
  }
};
